import styled from 'styled-components';

import { Title } from '../../../../../components/v2/Header';
import colors from '../../../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px;
`;

const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 10px;
  background-color: ${colors.shades.secondary10};
`;

const PanelTitle = styled(Title)`
  margin: 0;
  color: ${colors.base.secondary2};
`;

export { Container, PanelHeader, PanelTitle };
